export default [
  // highlevel staging
  "5DP4iH6HLkQsiKESj6rh", // GHL Staging (Non-white label)
  "r2jbhuFCqwY6C7Eee2GX", // chaitanya (white label)

  // highlevel prod
  "GNb7aIv4rQFVb9iwNl5K", // Highlevel Prod Test Agency 1 (Non-white label)
  "dWhRjUOXJTrzutFYMy1r", // Whitelabel $99 plan (white label)
  "ktapXmiRvMM4pJHyN3b3", //ProdQA
  // naman's agencies
  "n1UOVXuM12WmoSF9m1Pq", // staging whitelabel
  "ZUWg3W5vLMC13NnxuuoC", // staging non-whitelabel

  // mastermind
  "MbiFC7fMhLPL3UBhTyz8", // staging
  "7dZ2z694PJgE8aFdKJrI", // production

  // Lyons Den Solutions
  "a0M2mhE5SmFDYQYLJFPC", // production

  // Planet Wealth
  "n3ROEZdpoDuWf3hrzUee", // production
  "zrLcAaXCTmmJCSHnISJ2", // 0-119-600
  "YA62kGWvXhrnHdoiLqvT", // 0-381-418 Motor Auction Group
  "TnsOS88Os0lJqjhuj7c5", // 0-355-416 Iad Mexico
  "FrYUZlvdSGcxR5wqEhbf", // 0-401-129 Photobooth Supply Co
  "rvtR2VzrhmpBtREXlB0X", // 0-244-606 Fund Launch
  "4foBU2vEqYWgzhNhlZ0L", // 0-413-475 Haystax Mortgage Canada Inc.
  "u4d74GSQVhelflqRZdPz", // 0-357-325 Markster, Inc.
  "NkaIsfbRv42LhpeE1olh", // 0-412-241 Credit Repair Cloud
  "nfzQSUmUHiH0Hjrer8k1", // 0-261-931 Pennant App for Marketing
  "ddO1Rlox0CDzrTh6eeVH", // 0-010-255 One Park Financial
  "k2NcpII3u0jPrXt19afn", // 0-421-649 One Click Contractor CRM
  "mvxaAnBrxgjE5ZI8Xukm", // 0-201-078 Apex Pro AI Inc
  "PKQnbtUxwARo9eYfmwpP", // 0-048-648 Topline
  "YyRt09sbGDuMrHTtNgl7", // 0-202-973 Broker 360
  "TIPBFa3Te78FAy8Xdrw0", // 0-161-027 Alvyo Next
  "eFs2j3iZNmya4YBYxdvd", // 0-494-540 bizzbizz.io
  "oHl95tMhewGqZlySv3zl", // 0-086-622 Simpler Digital Marketing
  "K4CxHyAUdFaGm47JZp1u", // 0-199-506 VSS
  "pKaeFunSMRlfbUWGJVVt", // 0-505-694 FEA Create Test Agency
  "vpis3m6O9HQ1WlyZDRyT", // 0-486-725 Omnya CRM
  "Qe4YdQUqVrzcB6PiPIkn", // 0-369-372 QuantKey Solutions LLC
  "pNIFkU2znt2y9BESJbie", // 0-507-457 Symmetriq AI
  "oto2qg4TJf0wMuUCsy2r", // 0-450-271 PowerKr
  "cg0KeRYHtGpckPdKbOdk", // 0-353-940 Get My Sheet Done
  'N4Vpqtl7aBJGQGhyVo6o', // 0-200-666 Republic Financial Services
  'gPkTndcx94O3r573TOMx', // 0-361-592 AHA-Innovations
  'zZInvtx56W13XdkjPNTd', // 0-232-733 NurseLoop
  'OmcQtoncn2ZeI6fPav2e', // 0-352-345 Baker Real Estate Incorporated
  '0do8Lk8RgdfIg1niPbMV', // 0-002-416 Influx Marketing
  'Xm0xsysVrV1zt9JT1UPI', // 0-526-183 VYB Collective LLC
  'bR5MMv6JqiAx1g6ass5l', // 0-314-978 The Agency Plug
  'EpMUjhhBgImGRVcLfgId', // 0-017-029 GoGuru Pro
  'AU2sVR7AECPB9NXJnJcc', // 0-339-203 PowerChord
  'SusaRFWOCNd2V6M3jXsh', // 0-386-195 ProAdvisorCoach
  'aVz4ccsF1xoFuJJnOVpI', // 0-535-348 Church of the Highlands
  'XlFQSjVHwMxDEoxWXLh2', // 0-093-541 Magick
  'YCh6qo9uer6Ubk8qXxWB', // 0-465-069 SponsorCloud
  'dc910EFY4AWcmdXU42Oh', // 0-548-002 LLM Software
  'joSGGHiJ7zbbw4mojp6h', // 0-559-790 NexPhaz
  'Ttm0Nyc362jSrQTOH3Ge', // 0-547-517 Central Texas Community Foundation
  'NN8KdXWldPz0tgX15Eyb', // 0-132-612 Klanet
  'LkVgRYpfNwvhNiXQHKX3', // 0-400-325 True Destiny Digital Solutions
]
